export const SLICE_NAME = 'apple';
